import { render } from "./MarketingDetail.vue?vue&type=template&id=5640620d&scoped=true"
import script from "./MarketingDetail.vue?vue&type=script&lang=js"
export * from "./MarketingDetail.vue?vue&type=script&lang=js"

import "./MarketingDetail.vue?vue&type=style&index=0&id=5640620d&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5640620d"]])

export default __exports__